/**
 * 자산 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class AssetService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 보유 포지션 조회
     * 회원의 보유한 포지션 리스트를 조회한다.
     * @param request - 보유 포지션 조회 요청 데이터
     * @returns 보유 포지션 조회 결과
     */
    getAssetPositions(request) {
        return this.axios.get(`/main/v1/assets/positions`, {
            params: request,
        });
    }
    /**
     * 포지션증거금 조회
     * 회원의 보유한 증거금 리스트를 조회한다.
     * @param request - 포지션증거금 조회 요청 데이터
     * @returns 포지션증거금 조회 결과
     */
    getAssetPositionDeposits(request) {
        return this.axios.get(`/main/v1/assets/position/deposits`, {
            params: request,
        });
    }
    /**
     * 주문증거금 조회
     * 회원의 보유한 주문증거금 리스트를 조회한다.
     * @param request - 주문증거금 조회 요청 데이터
     * @returns 주문증거금 조회 결과
     */
    getAssetOrderDeposits(request) {
        return this.axios.get(`/main/v1/assets/order/deposits`, {
            params: request,
        });
    }
}
//# sourceMappingURL=asset.service.js.map